<template>
<div >
    <div class="fluid-container p-1 m-auto p-lg-0 ">
       <div class="col-12 col-lg-8 noprint m-auto p-2">
        <button type="button" class="btn "
        v-html="hideDelivered ? 'Show All'  : 'Hide Delivered' " 
        v-on:click="hideDelivered = ! hideDelivered" :class="hideDelivered ? 'btn-primary'  : 'btn-success' ">
        </button>  
       </div>

        <div  v-for="(value, key) in group"  :key="value.order_id"  class="page border rounded shadow p-2 col-12 col-lg-8 m-auto " >
            <h5>Group: {{key}}</h5>
             
            <table class="table" :class="{'small' : admin}">
               
                <thead class="thead-light">
                    <tr>
                        <th :width="admin ? '10%' : '30%'">Student Name</th>
                        <th :width="admin ? '10%' : '30%'">Parent Name</th>
                        <th :width="admin ? '5%' : '15%'">Quantity</th>
                        <th :width="admin ? '5%' : '15%'">Type</th>
                        <th class="noprint" width="12%" v-if="admin">Transaction ID</th>
                        <th class="noprint" width="7%" v-if="admin">Phone</th>
                        <th class="noprint" width="15%" v-if="admin">Email</th>
                        
                        <th class="noprint" :width="admin ? '6%' : '10%'">Delivered</th>
                    </tr>
                </thead>
                <tr v-for="order in value" :key="order.order_id" >
                    <td >{{order.name}}</td>
                    <td>{{order.parent_name}}</td>
                    <td>{{order.qty}}</td>
                    <td><strong class="badge">{{order.type}}</strong></td>
                    <td class="noprint" v-if="admin"><small>{{order.txn_id}}</small></td>
                    <td class="noprint" v-if="admin">{{order.phone_number}}
                    <td class="noprint" v-if="admin">{{order.email_address}}</td>
                   
                    <td class="noprint"><div class="led m-auto " 
                                v-if="admin" v-on:click="order.delivered = !order.delivered; setOrder(order.order_id, 'delivered', order.delivered)" :class="order.delivered  ? 'green'  : 'red' " >
                        </div>
                        <div class="led m-auto " 
                                v-if="!admin" :class="order.delivered  ? 'green'  : 'red' " >
                        </div>
                    </td>
                </tr>
                
            </table>
            <span v-for="group in totals" :key="group" >
                <em v-for="type in group[key]" :key="type" class = "ml-2 badge text-white bg-secondary border rounded shadow" >
                    {{ type.type }} Total: {{ type.TotalQty }} 
                </em>
            </span>

         
        </div>
  
    
    </div>
</div>
</template>

<script>

var groupBy = function(xs, key) {
    return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
};

var xGroup = function(xs, firstGroup, secondGroup) {
    var G = {}
    
	var grouped = groupBy(xs, firstGroup)
	for (var k in grouped){
		G[k] = (groupBy(grouped[k],secondGroup))		
	}	
	return G
}

/* eslint-disable */ 
  export default {
    name: "Orders",
    data() {
      return {
        group: '', 
        totals: {},
        hideDelivered: false
     
        }
    },
    props: {
      authenticated: {},
      admin: {}
    }, 
    methods: {

        setOrder(id, field,value) {

        let currentObj = this;
        let params = new URLSearchParams();
        params.append('task', 'editOrder');
        params.append('id', id);
        params.append('field', field)
         params.append('value', value)
        this.axios.post('https://www.aperturefilms.com.au/customer-portal/admin.php', params)
                .then(function (response) {
                    console.log(response.data)
                    //currentObj.getPerformance()
                })
                .catch(function (error) {
                    console.log(error);  
                });
      },

      LoadOrders() {
        let currentObj = this;
        let params = new URLSearchParams();
            params.append('task', 'listOrders');
            params.append('field', this.hideDelivered);
            this.axios.post('https://www.aperturefilms.com.au/customer-portal/admin.php', params)
                .then(function (response) {
                    if (response.data) {
                        currentObj.group = groupBy(response.data, 'class')
                    }

                })
                .catch(function (error) {
                    console.log(error);  
                });
      },

      LoadTotals() {
        let currentObj = this;
        let params = new URLSearchParams();
            params.append('task', 'countOrders');
            this.axios.post('https://www.aperturefilms.com.au/customer-portal/admin.php', params)
                .then(function (response) {
                    if (response.data) {
                        currentObj.totals = xGroup(response.data, 'type', 'class')
                       
                    }

                })
                .catch(function (error) {
                    console.log(error);  
                });
      }
    },
    mounted() {
        this.LoadOrders()
        //this.LoadTotals()
    },
    created(){
        this.LoadTotals()
    },
    watch: {
    // whenever question changes, this function will run
    hideDelivered: function () {
      this.LoadOrders()
    }
  }
    
  }
</script>

<style scoped>
.green {
    background-image: -webkit-linear-gradient(top, #13fB04 0%, #58e343 50%, #ADED99 100%);
}

.orange {
    background-image: -webkit-linear-gradient(top, #f9a004 0%, #e0ac45 50%, #ead698 100%);
}


.red {
    background-image: -webkit-linear-gradient(top, #fb1304 0%, #e35843 50%, #edad99 100%);
}


.led {
    border-radius: 5px;
    width: 10px;
    height: 10px;
    box-shadow: 0px 0px 3px black;
    margin: 5px;
    zoom: 1;
}

.led:after {
    display: block;            
    content: '';
    margin-left: 1px;
    margin-right: 1px;
    width: 8px;
    height: 6px;
    -webkit-border-top-right-radius: 4px 3px;
    -webkit-border-top-left-radius: 4px 3px;
    -webkit-border-bottom-right-radius: 4px 3px;
    -webkit-border-bottom-left-radius: 4px 3px;
    background-image: -webkit-linear-gradient(top, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.2) 100%);
}
table {
    table-layout: fixed;
}

td, th {
    overflow: hidden;
     white-space: nowrap;
}

@media print {
    .fluid-container {
        top:150px;
    }
   	.page {
		position:relative;
		top:90mm;
        page-break-after:always;
		
	}
     .noprint {
		display:none;
	}
    * {
        -webkit-print-color-adjust: exact;
    }

    
}



</style>

